// generated by genversion
export var version = '5.1.3';
//# sourceMappingURL=version.js.map